export default __webpack_public_path__ + "static/media/star-vector.aed60dea.svg";